var map = {
	"./admin-page/admin-page.module": [
		"./src/app/pages/admin-page/admin-page.module.ts",
		"admin-page-admin-page-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./directories-page/directories-page.module": [
		"./src/app/pages/directories-page/directories-page.module.ts",
		"directories-page-directories-page-module"
	],
	"./error-page/error-page.module": [
		"./src/app/pages/error-page/error-page.module.ts",
		"error-page-error-page-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./offerings-page/offerings-page.module": [
		"./src/app/pages/offerings-page/offerings-page.module.ts",
		"offerings-page-offerings-page-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"pages-pages-module"
	],
	"./profile/profile.module": [
		"./src/app/pages/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./repositories-page/repositories-page.module": [
		"./src/app/pages/repositories-page/repositories-page.module.ts",
		"repositories-page-repositories-page-module"
	],
	"./resources-page/resources-page.module": [
		"./src/app/pages/resources-page/resources-page.module.ts",
		"resources-page-resources-page-module"
	],
	"./settings-page/settings-page.module": [
		"./src/app/pages/settings-page/settings-page.module.ts",
		"settings-page-settings-page-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;